export default __webpack_public_path__ + "static/media/hand_phone_sm.13ce86e0.png";